<template>
  <div v-if="facilityShisetsuData || facilityFutaiData" :class="wrapperClass">
    <h3 class=" c-title2" :class="headingClass">
      設備・サービス詳細
    </h3>
    <div class="p-menu-facility-service">
      <!-- {{facility}} -->
      <ul class="p-menu-facility-service__table-list">
        <li
          v-for="(item, index) in facilityShisetsuData"
          :key="index"
          class="p-menu-facility-service__table-list__item p-menu-facility-service__table-list__item--label"
        >
          <p class="p-menu-facility-service__table-list__text">
            {{ item.equipServNm1 }}
          </p>
          <p class="p-menu-facility-service__table-list__text-mark">
            {{ item.equipServValue1 }}
          </p>
        </li>
      </ul>

      <ul
        class="p-menu-facility-service__table-list p-menu-facility-service__table-list-futai"
      >
        <li
          v-for="(item, index) in facilityFutaiData"
          :key="index"
          class="p-menu-facility-service__table-list__item p-menu-facility-service__table-list__item--label"
        >
          <p class="p-menu-facility-service__table-list__text">
            {{ item.equipServNm1 }}
          </p>
          <p class="p-menu-facility-service__table-list__text-mark">
            {{ item.equipServValue1 }}
          </p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    facility: {
      type: Object,
      default: () => ({})
    },
    // 通常画面とモーダルでのclassの切り替えに使用
    view: {
      type: String,
      default: () => "normal"
    }
  },
  data() {
    return {};
  },
  computed: {
    facilityShisetsuData() {
      if (!this.facility) return false;
      if (
        this.facility.equipServices &&
        this.facility.equipServices[0] &&
        this.facility.equipServices[0].equipServDetail1 &&
        this.facility.equipServices[0].equipServDetail1[0]
      ) {
        return this.facility.equipServices[0].equipServDetail1;
      } else {
        return false;
      }
    },
    facilityFutaiData() {
      if (!this.facility) return {};
      if (
        this.facility.equipServices &&
        this.facility.equipServices[1] &&
        this.facility.equipServices[1].equipServDetail1 &&
        this.facility.equipServices[1].equipServDetail1[0]
      ) {
        return this.facility.equipServices[1].equipServDetail1;
      } else {
        return false;
      }
    },
    wrapperClass() {
      return this.view === "modal"
        ? "p-menu-store-list__modal__block"
        : "p-menus-no-detail__block";
    },
    headingClass() {
      return this.view === "modal"
        ? "-menu-store-list__modal__block__title"
        : "p-menus-no-detail__block__title";
    }
  },
  methods: {
    isExist(val) {
      return val ? "○" : "×";
    }
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
@import './style.scss';
</style>
